module.exports = __webpack_public_path__ + "static/media/iconNote.16c079dd.svg";